<!--login signup passwords restablecer-->

<div class="login bg-color-primary login--signup animate  min-h-screen   h-auto bg-color-primary">
        <!--lenguaje-->
        <div class=" absolute translate-reset sm-translate-reset" style="display:none !important;">
            <ng-container *ngIf="selectData.interfaceLanguages.length">
                <msc-common-select [data]="selectData.interfaceLanguages" id="translate-signup">
                    <ng-template #buttonTemplate let-data="data">
                        <button class="select-main">
                            <ng-container *ngIf="data?.length">
                                <img
                                    src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{data[0].value.code}}.svg">
                                <span>{{ data[0].label }}</span>
                            </ng-container>
                        </button>
                    </ng-template>
                    <ng-template #optionTemplate let-datum="datum">
                        <button class="select-option" (click)="onSelectOption(datum)">
                            <img
                                src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{datum.value.code}}.svg">
                            <span>{{ datum.label }}</span>
                        </button>
                    </ng-template>
                </msc-common-select>
            </ng-container>
        </div>

        <!--invitacion antiguo-->
        <div class="login__body box box--shadow" id="login-signup" *ngIf="data" style="display: none !important;">
            <div class="login__header">
                <!-- <a class="login__logo">
                <img *ngIf="!display.logo" src="https://webservices.griky.co/cdn/img/Griky-Logotipo.webp" alt="MySkillCamp">
                <img *ngIf="display.logo" [src]="display.logo + '?size=256'" [alt]="display.name">
            </a>-->

                <div class="login__logo">
                    <div class="login__logo__container mx-auto h-15 w-3/5 " *ngIf="!display.logo"
                        [style.backgroundImage]="'url(https://webservices.griky.co/cdn/img/Griky-Logotipo.webp)'"></div>
                    <div class="login__logo__container mx-auto h-15 w-3/5" *ngIf="display.logo"
                        [style.backgroundImage]="'url(' + display.logo + '?size=512)'"></div>
                </div>
            </div>

            <div class="signup__form">
                <div class="form__item">
                    <msc-input [label]="'words.email' | translate" type="text" id="email" [ngModel]="data.email"
                        disabled></msc-input>
                </div>

                <div class="form__item form__item--half">
                    <div class="col-6">
                        <msc-input [label]="'words.firstname' | translate" type="text" id="firstname"
                            [(ngModel)]="data.firstname"></msc-input>
                    </div>

                    <div class="col-6">
                        <msc-input [label]="'words.lastname' | translate" type="text" id="lastname"
                            [(ngModel)]="data.lastname"></msc-input>
                    </div>
                </div>

                <div class="form__item d-none">
                    <label class="input__label" for="firstname" style="display: none;">
                        {{ 'words.interface-language' | translate }}
                    </label>

                    <ng-container *ngIf="selectData.interfaceLanguages.length" style="display: none;">
                        <msc-common-select [data]="selectData.interfaceLanguages" style="display: none;">
                            <ng-template #buttonTemplate let-data="data">
                                <button class="select-main">
                                    <ng-container *ngIf="data?.length">
                                        <img
                                            src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{data[0].value.code}}.svg">
                                        <span>{{ data[0].label }}</span>
                                    </ng-container>
                                </button>
                            </ng-template>
                            <ng-template #optionTemplate let-datum="datum">
                                <button class="select-option" (click)="onSelectOption(datum)">
                                    <img
                                        src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{datum.value.code}}.svg">
                                    <span>{{ datum.label }}</span>
                                </button>
                            </ng-template>
                        </msc-common-select>
                    </ng-container>
                </div>

                <div class="form__item">
                    <msc-input [label]="'words.password' | translate" type="password" id="password"
                        [(ngModel)]="data.password" [debounce]="500"
                        (onDebounce)="trimPassword('password')"></msc-input>
                </div>

                <div class="form__item">
                    <msc-input [label]="'words.confirm-password' | translate" type="password" id="confirm_password"
                        [(ngModel)]="data.password_confirmation" [debounce]="500"
                        (onDebounce)="trimPassword('password_confirmation')"></msc-input>
                </div>

                <p class="color--grey text-error" [ngClass]="{'active': error.short, 'valid': valid.short}">
                    <i *ngIf="error.short" class="icon icon-close"></i>
                    <i *ngIf="valid.short" class="icon icon-checkmark-1"></i>
                    {{ "error.password.too-short" | translate }}
                </p>
                <p class="color--grey text-error" [ngClass]="{'active': error.number, 'valid': valid.number}">
                    <i *ngIf="error.number" class="icon icon-close"></i>
                    <i *ngIf="valid.number" class="icon icon-checkmark-1"></i>
                    {{ "error.password.number" | translate }}
                </p>
                <p class="color--grey text-error" [ngClass]="{'active': error.uppercase, 'valid': valid.uppercase}">
                    <i *ngIf="error.uppercase" class="icon icon-close"></i>
                    <i *ngIf="valid.uppercase" class="icon icon-checkmark-1"></i>
                    {{ "error.password.uppercase" | translate }}
                </p>
                <p class="color--grey text-error" [ngClass]="{'active': error.lowercase, 'valid': valid.lowercase}">
                    <i *ngIf="error.lowercase" class="icon icon-close"></i>
                    <i *ngIf="valid.lowercase" class="icon icon-checkmark-1"></i>
                    {{ "error.password.lowercase" | translate }}
                </p>

                <p class="color--red text-error" *ngIf="error.confirm">
                    <i class="icon icon-close"></i>
                    {{ "error.password.no-match" | translate }}
                </p>

                <div class="form__item form__item--privacy mt-8">
                    <msc-button class="msc-button--primary" palette="primary" (click)="save()"
                        [disabled]="data.password.length === 0 || error.characters || error.number || error.lowercase || error.uppercase || error.short || error.confirm">
                        {{ 'words.save' | translate }}
                    </msc-button>
                </div>
            </div>
        </div>


        <!--invitacion new design-->
        <div class="mx-auto w-full max-w-4xl rounded-2xl overflow-hidden shadow-lg flex flex-col lg:flex-row  bg-white"
            id="login-signup" *ngIf="data">
            <!-- col izquierdo -->
            <div class="hidden lg:flex flex-col justify-center items-start p-10 gap-4 bg-gradient-to-br from-primary to-[var(--v2-color-primary-300)] text-white"
                style="background-image: linear-gradient(135deg, var(--v2-color-primary-500) 0%, var(--v2-color-primary-300) 100%) !important;">

                <div class="mb-4">
                    <div class="w-28 h-28 rounded-full relative overflow-hidden bg-center bg-cover"
                        style="background-position:center; background-size:cover;">
                        <!-- Overlay para mejorar contraste del icono sobre la imagen -->
                        <div class="absolute inset-0 bg-black/25"></div>
                        <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
                            <i class="fa fa-user text-4xl text-white" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>

                <h2 class="text-2xl font-semibold">{{ "words.welcome-realy" | translate }}</h2>
                <p class="text-sm opacity-90 max-w-xs">
                   {{ "words.description-signup" | translate }}
                </p>

                <ul class="mt-4 space-y-2 text-sm">
                    <li class="flex items-center gap-2">
                        <i class="icon icon-checkmark-1"></i>
                        <span>{{ "words.security" | translate }}</span>
                    </li>
                    <li class="flex items-center gap-2">
                        <i class="icon icon-checkmark-1"></i>
                        <span>{{ "words.quick-access" | translate }}</span>
                    </li>
                </ul>
            </div>

            <!-- col derecho formulario -->
            <div class="bg-white m-4 p-8 sm:p-10">
                <div class="login__header pb-6 mb-6">
                    <div class="login__logo">
                        <div class="login__logo__container mx-auto h-15 w-3/5 " *ngIf="!display.logo"
                            [style.backgroundImage]="'url(https://webservices.griky.co/cdn/img/Griky-Logotipo.webp)'" style="max-height: 100px;">
                        </div>
                        <div class="login__logo__container mx-auto h-15 w-3/5" *ngIf="display.logo"
                            [style.backgroundImage]="'url(' + display.logo + '?size=512)'" style="max-height: 100px;"></div>
                    </div>
                </div>

                <div class="signup__form space-y-6">
                    <div class="form__item">
                        <msc-input [label]="'words.email' | translate" type="text" id="email" [ngModel]="data.email"
                            disabled></msc-input>
                    </div>

                    <div class="form__item form__item--half grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <msc-input [label]="'words.firstname' | translate" type="text" id="firstname"
                                [(ngModel)]="data.firstname"></msc-input>
                        </div>
                        <div>
                            <msc-input [label]="'words.lastname' | translate" type="text" id="lastname"
                                [(ngModel)]="data.lastname"></msc-input>
                        </div>
                    </div>

                    <div class="form__item">
                        <msc-input [label]="'words.password' | translate" type="password" id="password"
                            [(ngModel)]="data.password" [debounce]="500"
                            (onDebounce)="trimPassword('password')"></msc-input>
                    </div>

                    <div class="form__item">
                        <msc-input [label]="'words.confirm-password' | translate" type="password" id="confirm_password"
                            [(ngModel)]="data.password_confirmation" [debounce]="500"
                            (onDebounce)="trimPassword('password_confirmation')"></msc-input>
                    </div>

                    <div class="form__item d-none">
                        <label class="input__label" for="firstname" style="display: none;">
                            {{ 'words.interface-language' | translate }}
                        </label>

                        <ng-container *ngIf="selectData.interfaceLanguages.length" style="display: none;">
                            <msc-common-select [data]="selectData.interfaceLanguages" style="display: none;">
                                <ng-template #buttonTemplate let-data="data">
                                    <button class="select-main">
                                        <ng-container *ngIf="data?.length">
                                            <img
                                                src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{data[0].value.code}}.svg">
                                            <span>{{ data[0].label }}</span>
                                        </ng-container>
                                    </button>
                                </ng-template>
                                <ng-template #optionTemplate let-datum="datum">
                                    <button class="select-option" (click)="onSelectOption(datum)">
                                        <img
                                            src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{datum.value.code}}.svg">
                                        <span>{{ datum.label }}</span>
                                    </button>
                                </ng-template>
                            </msc-common-select>
                        </ng-container>
                    </div>

                    <!-- Mostrar reglas SOLO si el usuario ha empezado a escribir en password -->
                    <div *ngIf="data?.password?.length > 0" class="space-y-1 text-sm"
                        style="margin: 1.5rem 0 !important;">

                        <p class="password-rule" [ngClass]="{'active': error.short, 'valid': valid.short}">
                            <i *ngIf="valid.short" class="icon icon-checkmark-1 rule-icon success"
                                aria-hidden="true"></i>
                            <i *ngIf="error.short" class="icon icon-close rule-icon error" aria-hidden="true"></i>
                            <span class="password-rule-text">{{ "error.password.too-short" | translate }}</span>
                        </p>

                        <p class="password-rule" [ngClass]="{'active': error.number, 'valid': valid.number}">
                            <i *ngIf="valid.number" class="icon icon-checkmark-1 rule-icon success"
                                aria-hidden="true"></i>
                            <i *ngIf="error.number" class="icon icon-close rule-icon error" aria-hidden="true"></i>
                            <span class="password-rule-text">{{ "error.password.number" | translate }}</span>
                        </p>

                        <p class="password-rule" [ngClass]="{'active': error.uppercase, 'valid': valid.uppercase}">
                            <i *ngIf="valid.uppercase" class="icon icon-checkmark-1 rule-icon success"
                                aria-hidden="true"></i>
                            <i *ngIf="error.uppercase" class="icon icon-close rule-icon error" aria-hidden="true"></i>
                            <span class="password-rule-text">{{ "error.password.uppercase" | translate }}</span>
                        </p>

                        <p class="password-rule" [ngClass]="{'active': error.lowercase, 'valid': valid.lowercase}">
                            <i *ngIf="valid.lowercase" class="icon icon-checkmark-1 rule-icon success"
                                aria-hidden="true"></i>
                            <i *ngIf="error.lowercase" class="icon icon-close rule-icon error" aria-hidden="true"></i>
                            <span class="password-rule-text">{{ "error.password.lowercase" | translate }}</span>
                        </p>

                        <!-- Mensaje de confirmación -->
                        <p class="color--red text-error text-sm" *ngIf="error.confirm" role="alert">
                            <i class="icon icon-close rule-icon error"></i>
                            {{ "error.password.no-match" | translate }}
                        </p>
                    </div>

                    <div class="form__item form__item--privacy mt-6" style="margin-top: 3rem !important;">
                        <msc-button class="msc-button--primary w-full py-3 rounded-md" palette="primary"
                            (click)="save()"
                            [disabled]="data.password.length === 0 || error.characters || error.number || error.lowercase || error.uppercase || error.short || error.confirm">
                            {{ 'words.save' | translate }}
                        </msc-button>
                    </div>
                </div>
            </div>
        </div>
    </div>